<template>
  <div  v-title data-title="消息详情">
    <wv-form-preview class="preview-item" title="标题" :value="detail.Title" :dataItems="dataItems" />
  </div>
</template>

<script>
import { Toast } from "we-vue";

export default {
  name: "messagedetail",
  data: function() {
    return {
      detail: {},
      dataItems: []
    };
  },
  mounted: function() {
    this.InitMessageDetail();
  },
  methods: {
    tabbarclick: function(to, index) {
      this.$router.push(to);
      this.isonindex = index;
    },
    InitMessageDetail: function() {
      this.$http
        .get(this.GLOBAL.BASE_URL + "api/messagedetail/detail", {
          params: {
            id: this.$route.query.id
          }
        })
        .then(
          function(d) {
            var rep = JSON.parse(d.bodyText);
            if (rep.Success) {
              this.detail = rep.Data;
              for (var key in this.detail.Detail) {
                var item = {
                  label: key,
                  value: this.detail.Detail[key]
                };
                this.dataItems.push(item);
              }
            } else {
              Toast.fail(rep.Message);
            }
          },
          function(d) {
            console.log(d);
          }
        );
    }
  }
};
</script>




// WEBPACK FOOTER //
// src/components/message/messagedetail.vue